import React, { useEffect } from "react";
import "../style/page/Partner.css";
import { usePartnerContent } from "../hooks/usePartnerContent";
import LogoStrip from "../component/HomePage/LogoStrip";
import { useLogoStripCarousel } from "../hooks/websiteHooks";

function Partner() {
  const { title, description, cards, logos, metaTitle } = usePartnerContent();
  useLogoStripCarousel([logos.length]);

  // Update page title when content changes
  useEffect(() => {
    if (metaTitle) {
      document.title = metaTitle;
    }
  }, [metaTitle]);

  return (
    <main className="main-content partner-page">
      <h4 className="page-title">{title}</h4>

      <p className="description">{description}</p>

      <div className="contact-wrapper">
        {cards.map((card) => (
          <div className="contact-card" key={card.id}>
            <h2 className="contact-title">
              {card.website_url ? (
                <a href={card.website_url} target="_blank" rel="noopener noreferrer" className="partner-name-link">
                  <span className="partner-name-text">{card.name}</span>
                </a>
              ) : (
                <span className="partner-name-text">{card.name}</span>
              )}
            </h2>
            <p className="contact-text">{card.description}</p>
          </div>
        ))}
      </div>

      <LogoStrip id="partners" title={title} items={logos} />
    </main>
  );
}

export default Partner;
